module.exports = __webpack_public_path__ + "static/media/christopher_robin.17492c8e.jpg";